import { Mode } from '~/types/client';

/**
 * Normalise un screenID avant persistance Firestore (collecteurs de sessions).
 *
 * Garde-fou contre le bug historique où un screenID non résolu était écrit dans
 * `gamepadSession`/`screenSession`/`playerVisit` comme la chaîne littérale
 * "undefined" — environ 69% des sessions de l'aéroport Marseille (airport-MRS)
 * entre juin 2025 et juin 2026, rendues invisibles au dashboard (filtré par écran).
 *
 * Le guard `screenID || Mode.Anim` côté appelant ne rattrape PAS les chaînes
 * "undefined"/"null"/"" non vides (elles sont truthy). On normalise donc ici, au
 * point d'écriture, pour qu'aucun collecteur ne puisse jamais persister une valeur
 * parasite : tout screenID absent ou invalide retombe sur `Mode.Anim`.
 */
export function normalizeScreenID(screenID?: string | null): string {
    const normalized = (screenID ?? '').trim();
    const lower = normalized.toLowerCase();
    if (!normalized || lower === 'undefined' || lower === 'null') {
        return Mode.Anim;
    }
    return normalized;
}
